/**
 * Resolves whether the buy/sell wizard can advance from the given step.
 *
 * Every asynchronous step is awaited, so the wizard only moves forward once the
 * step work (food debt lookup, pretransfer save) actually finished. A rejection
 * is propagated to the caller, which keeps the user on the current step.
 */
export async function executeStepAction(step, deps) {
  const {
    loadFoodDebt,
    updateTransferOnStepChange,
    openCavConditionsModal,
    aceptedCondition,
  } = deps;

  switch (step) {
    case 0:
      await loadFoodDebt();
      await updateTransferOnStepChange(0);
      return true;

    case 1:
      if (!aceptedCondition) {
        openCavConditionsModal();
        return false;
      }
      return true;

    case 2:
      await updateTransferOnStepChange(2);
      return true;

    case 3:
      return true;

    default:
      return false;
  }
}
